import { MutationTree } from 'vuex';
import { InsurersReportsState } from '@/store/modules/insurers-reports/index';
import { Grid } from '@/models/Grid.model';
import { InsurersReportModel } from '@/models/backoffice/InsurersReportModel';
import {
  SET_INSURERS_REPORTS,
  SET_INSURERS_REPORTS_ERRORS,
  SET_INSURERS_REPORTS_LOADING,
} from '@/types/insurers-reports.types';

export const mutations: MutationTree<InsurersReportsState> = {

  [SET_INSURERS_REPORTS_ERRORS]: (state, insurersReportsErrors: string[]) => {
    state.insurersReportsErrors = insurersReportsErrors;
  },

  [SET_INSURERS_REPORTS_LOADING]: (state, insurersReportsLoading: boolean) => {
    state.insurersReportsLoading = insurersReportsLoading;
  },

  [SET_INSURERS_REPORTS]: (state, insurersReports: Grid<InsurersReportModel>) => {
    state.insurersReportsList = insurersReports;
  },
};
